import { createSlice } from '@reduxjs/toolkit';
import { IssuedCouponData } from '@src/types/coupon';
import {
  getCouponOptionList,
  getIssuedCouponList,
} from './issuedCouponListThunk';
import { CouponListModalType } from '../types';

interface IssuedCouponListState {
  loading: boolean;
  optionSearchLoading: boolean;
  coupons: IssuedCouponData[];
  options: { value: string; label: string }[];
  modal: CouponListModalType[];
  selected?: { name: string; id: string };
  meta: {
    itemsPerPage?: number;
    totalItems?: number;
    currentPage?: number;
    totalPages?: number;
  };
  params: {
    page: number;
    limit: number;
    search: string;
  };
}

const initialState: IssuedCouponListState = {
  loading: false,
  optionSearchLoading: false,
  coupons: [],
  options: [],
  modal: [],
  meta: {},
  params: {
    page: 1,
    limit: 20,
    search: '',
  },
};

const issuedCouponsSlice = createSlice({
  name: 'issuedCoupons',
  initialState,
  reducers: {
    onChangeSearchValue(state, { payload }) {
      state.params.search = payload;
    },
    onChangePage(state, { payload }) {
      state.params.page = payload;
    },
    onChangeModal(state, { payload }) {
      if (payload === 'off') {
        state.modal = [];
      } else if (state.modal.includes(payload)) {
        state.modal = state.modal.filter((modal) => modal !== payload);
      } else {
        state.modal = [...state.modal, payload];
      }
    },
    onActionSelected(state, { payload }) {
      state.selected = payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getIssuedCouponList.pending, (state) => {
        state.loading = true;
      })
      .addCase(getIssuedCouponList.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.coupons = payload.data;
        state.meta = payload.meta;
      })
      .addCase(getIssuedCouponList.rejected, (state) => {
        state.loading = false;
      });

    builder
      .addCase(getCouponOptionList.pending, (state) => {
        state.optionSearchLoading = true;
      })
      .addCase(getCouponOptionList.fulfilled, (state, { payload }) => {
        state.options = payload.data.map((coupon) => ({
          value: coupon.id,
          label: coupon.name,
        }));
        state.optionSearchLoading = false;
      })
      .addCase(getCouponOptionList.rejected, (state) => {
        state.optionSearchLoading = false;
      });
  },
});

export const {
  onChangeSearchValue,
  onChangePage,
  onChangeModal,
  onActionSelected,
} = issuedCouponsSlice.actions;
export default issuedCouponsSlice.reducer;
